import React from "react"
import PopularArticlesSidebar from '../components/popular-articles-sidebar'

import Post from '../components/blog-post'
import ServicesDumpsters from "../components/services-dumpsters"
import LayoutDumpster from "../components/layout-dumpster"
import HowToGuidesSidebar from "../components/how-to-guides-sidebar"
import SidebarForm from "../components/sidebarForm"

const BLOGXXXPAGEDUMPSTERS = ({ data, pageContext }) => 
{ 
    const title = pageContext.post.title !== undefined ? pageContext.post.title : '';  
    const post = pageContext.post; 
    const env = pageContext.env;
    const code = pageContext.code;
    const populars = pageContext.populars;
    
    const seo = 
    {
        url: post.url,
        env: env,
        code: code,
        page: 'blog',
        blog: post
    }

    return (
        <LayoutDumpster seo={seo} env={env} code={code} bgcolor={'#f5f5f5'} hidden={true} callToAction={true}>

            <div className="blog">

                <div className="container mb-5">
                    <div className="row">
                        <div className="col-lg-8">
                            <h1 className="main-title">{title}</h1>
                            <div className="posts">
                                <Post post={post} />
                            </div>
                            
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar">
                                <div className="block">
                                    <div className="card mb-5">                                   
                                        <SidebarForm site={env.site} code="dumpster" section="blogs"/>
                                    </div>
                                </div>

                                <div className="block">
                                    <div className="card mb-5">                                 
                                        <SidebarForm site={env.site} code="junk-removal" section="blogs"/>
                                    </div>
                                </div>

                                <div className="block">
                                    <ServicesDumpsters  env={env}  />
                                </div>                                

                                <div className="block">
                                    <HowToGuidesSidebar/>
                                </div>

                                <div className="block">
                                    <PopularArticlesSidebar populars={populars} />
                                </div>                                

                            </div>                            
                        </div>
                    </div>
                </div> 
            
            
            </div> 

        </LayoutDumpster>
    )
};

export default BLOGXXXPAGEDUMPSTERS;